module.exports = __webpack_public_path__ + "ais_demo.3d7a9e9bdb2bd7748b09e5044196c695.mp4";